import dayjs from 'dayjs';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { useEvent } from 'react-use-event-hook';

interface ProgressBarProps {
  data?: any;
  onSetIndex: (index: number, time: string) => void;
  onClose?: () => void;
}

const SliderMap = ({ data, onSetIndex, onClose }: ProgressBarProps) => {
  const [index, setIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [playData, setPlayData] = useState<any>(undefined);

  const displayDate = (data: any) => {
    if (data !== undefined && data[index] !== undefined) {
      return dayjs(data[index].saveTime === undefined ? data[index].replace(/[.]/g, '/') : data[index].saveTime).format(
        'YY.MM.DD HH:mm:ss'
      );
    } else {
      return '00.00.00 00:00:00';
    }
  };

  const onPlay = (idx: number) => {
    if (isPlaying) return;
    setIndex(idx);
    onSetIndex(idx, playData[idx].saveTime);
    setIsPlaying(true);
  };

  const onStop = () => {
    if (!isPlaying) return;
    setIsPlaying(false);
  };

  const update = useEvent(() => {
    if (!isPlaying) return;
    const isLast: boolean = playData.length === index + 1;
    if (isLast) {
      setIsPlaying(false);
    } else if (playData.length > index + 1) {
      setIndex(index + 1);
      onSetIndex(index + 1, playData[index + 1].saveTime);
    }
  });

  const onChange = (value: number | number[] | undefined) => {
    if (value !== undefined && typeof value === 'number') {
      setIndex(value);
      onSetIndex(value, playData[value].saveTime);
    }
  };

  useEffect(() => {
    let interval: any;
    if (isPlaying) {
      interval = setInterval(() => {
        update();
      }, 500);
    }
    return () => clearInterval(interval);
  }, [isPlaying]);

  useEffect(() => {
    setIndex(0);
    if (data !== undefined && data.length > 0) {
      setPlayData(data);
      setIsPlaying(true);
    } else {
      setPlayData(undefined);
      setIsPlaying(false);
    }
  }, [data]);

  return (
    <ProgressBarTemplate>
      {isPlaying ? (
        <PlayButton onClick={onStop}>
          <img src={process.env.PUBLIC_URL + '/images/btn_slider_stop.svg'} alt="Stop" />
        </PlayButton>
      ) : (
        <PlayButton onClick={() => onPlay(index)}>
          <img src={process.env.PUBLIC_URL + '/images/btn_slider_play.svg'} alt="Play" />
        </PlayButton>
      )}
      <SliderTrackWrap>
        <img src={process.env.PUBLIC_URL + '/images/img_slider.svg'} alt="Slider" />
      </SliderTrackWrap>
      <DateWrap>{displayDate(playData)}</DateWrap>
      <SliderWrap>
        {playData !== undefined && (
          <Slider
            railStyle={{ backgroundColor: '#000', height: 16 }}
            trackStyle={{ backgroundColor: '#F2FFA1', height: 8, marginTop: 5 }}
            handleStyle={{
              borderColor: 'transparent',
              marginTop: 3,
              backgroundColor: 'transparent',
            }}
            max={playData.length - 1}
            value={index}
            onChange={onChange}
          ></Slider>
        )}
      </SliderWrap>
      {onClose !== undefined && (
        <CloseButton onClick={onClose}>
          <img src={process.env.PUBLIC_URL + '/images/btn_slider_close.svg'} alt="Close" />
        </CloseButton>
      )}
    </ProgressBarTemplate>
  );
};

const ProgressBarTemplate = styled.div`
  position: absolute;
  display: flex;
  width: 570px;
  height: 48px;
  bottom: 100px;
  // border: 1px solid #d9d9d9;
  border-radius: 30px;
  // background: #fff;
  z-index: 10;
  left: 50%;
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
`;
const SliderTrackWrap = styled.div`
  position: absolute;
  align-items: center;
  width: 456px;
  height: 30px;
  top: 9px;
  left: 57px;
`;
const DateWrap = styled.div`
  position: absolute;
  width: 143px;
  height: 22px;
  background: transparent;
  top: 13px;
  left: 67px;
  color: #fff;
  font-family: Inter;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  z-index: 1;
`;
const SliderWrap = styled.div`
  position: absolute;
  width: 285px;
  height: 16px;
  top: 10px;
  left: 220px;
`;
const PlayButton = styled.button`
  position: absolute;
  top: 10px;
  left: 20px;
  border: none;
  cursor: pointer;
  background: transparent;
  padding: 0px;
  z-index: 1;
`;
const CloseButton = styled.button`
  position: absolute;
  top: 9px;
  right: 20px;
  border: none;
  cursor: pointer;
  background: transparent;
  padding: 0px;
  z-index: 1;
`;

export default SliderMap;
